import client from './client';

export async function listLeadSources(params) {
  const { data } = await client.get('/lead-sources', { params });
  return data.data;
}

export async function createLeadSource(payload) {
  const { data } = await client.post('/lead-sources', payload);
  return data.data;
}

export async function updateLeadSource(id, payload) {
  const { data } = await client.put(`/lead-sources/${id}`, payload);
  return data.data;
}

export async function deleteLeadSource(id) {
  await client.delete(`/lead-sources/${id}`);
}

export async function listNationalities(params) {
  const { data } = await client.get('/nationalities', { params });
  return data.data;
}

export async function createNationality(payload) {
  const { data } = await client.post('/nationalities', payload);
  return data.data;
}

export async function updateNationality(id, payload) {
  const { data } = await client.put(`/nationalities/${id}`, payload);
  return data.data;
}

export async function deleteNationality(id) {
  await client.delete(`/nationalities/${id}`);
}
